import React, { useState } from "react";
import styles from "./formaddress.module.css";

type Tadress = {
  func: React.Dispatch<React.SetStateAction<string>>;
};

const FormAddress = (props: Tadress) => {
  const setdata = props.func;
  const [district, setDistrict] = useState("");
  const [street, setStreet] = useState("");
  const [door, setDoor] = useState("");
  const [flat, setFlat] = useState("");
  const [flor, setFlor] = useState("");

  const changeDistr = (e: any) => {
    setDistrict(e.target.value);
  };
  const changeStreet = (e: any) => {
    setStreet(e.target.value);
    setdata(
      `район:${district}, улица:${street}, дверь:${door}, квартира:${flat}, этаж:${flor}`
    );
  };

  const changeDoor = (e: any) => {
    setDoor(e.target.value);
    setdata(
      `район:${district}, улица:${street}, дверь:${door}, квартира:${flat}, этаж:${flor}`
    );
  };

  const changeFlat = (e: any) => {
    setFlat(e.target.value);
    setdata(
      `район:${district}, улица:${street}, дверь:${door}, квартира:${flat}, этаж:${flor}`
    );
  };
  const changeFlor = (e: any) => {
    setFlor(e.target.value);
    setdata(
      `район:${district}, улица:${street}, дверь:${door}, квартира:${flat}, этаж:${flor}`
    );
  };
  return (
    <div className={styles.main}>
      <div className={styles.text}>Район</div>
      <input
        className={styles.userBox}
        type="text"
        value={district}
        name="district"
        onChange={changeDistr}
        placeholder="Район"
      />
      <div className={styles.text}>Улица</div>
      <input
        className={styles.userBox}
        type="text"
        value={street}
        name="street"
        onChange={changeStreet}
        placeholder="Улица"
      />
      <div className={styles.text}>Дверь</div>
      <input
        className={styles.userBox}
        type="text"
        value={door}
        name="door"
        onChange={changeDoor}
        placeholder="Дверь"
      />
      <div className={styles.text}>Квартира</div>
      <input
        className={styles.userBox}
        type="text"
        value={flat}
        name="flat"
        onChange={changeFlat}
        placeholder="Квартира"
      />
      <div className={styles.text}>Этаж</div>
      <input
        className={styles.userBox}
        type="text"
        value={flor}
        name="flor"
        onChange={changeFlor}
        placeholder="Этаж"
      />
      <div className={styles.text}>
        Мы работаем только в зоне Большого Порту
      </div>
    </div>
  );
};

export default FormAddress;
